import { UseQueryResult, useQueries } from "@tanstack/react-query";

import { getFieldCropRecommendations } from "services";

import { GET_FIELDS_CROP_RECOMMENDATIONS } from "consts";

import { FieldCropRecommendationsResponse } from "models";

export type useGetAllFieldsRecommendationsReturnType = Pick<UseQueryResult<FieldCropRecommendationsResponse>, "data" | "isFetching" | "isLoading">;

export const useGetAllFieldsRecommendations = (fieldsInView: string[]): useGetAllFieldsRecommendationsReturnType => {
  const queries = fieldsInView.map((fieldId) => ({
    queryKey: [GET_FIELDS_CROP_RECOMMENDATIONS, [fieldId]],
    queryFn: () => getFieldCropRecommendations({ fieldIds: [fieldId] }),
    staleTime: 1000 * 60 * 5, // 5 minutes, tradeoff between perf and relevance
  }));

  return useQueries({
    queries,
    combine: (results) => ({
      data: results.reduce((acc, result) => ({ ...acc, ...result.data }), {}),
      isLoading: results.some((result) => !!result.isLoading),
      isFetching: results.some((result) => !!result.isFetching),
    }),
  });
};
